import React from "react";
import { Container } from "react-bootstrap";
import {
  FaInfoCircle,
  FaShieldAlt,
  FaBan,
  FaMusic,
  FaGavel,
  FaExclamationTriangle,
  FaUsersCog,
  FaUserCheck,
  FaSyncAlt,
} from "react-icons/fa";
import "./TNC.css";

const ContentPolicy = () => {
  return (
    <div className="tnc-container">
      <Container>
        <div className="tnc-wrapper">
          {/* Header Section */}
          <div className="tnc-header">
            
            <h1 className="main-title">
              <span className="text-yellow">Content</span>{" "}
              <span className="text-pink">Policy</span>
            </h1>
            <p className="intro-text">
              FT Tunes is committed to maintaining a safe, respectful, and legally
              compliant music distribution platform. This Content Policy outlines
              the rules and standards all users must follow when uploading,
              distributing, or promoting content through our services.
            </p>
          </div>

          {/* Section 1 */}
          <div className="policy-section card-gradient-border">
            <h2 className="section-title">
              <span className="section-number purple-gradient">1</span>
              <FaShieldAlt className="section-icon-inline mr-2 text-purple" />{" "}
              Ownership of Content
            </h2>
            <p className="section-text">
              Users must own or have full legal rights, licenses, and permissions
              to distribute any music, artwork, videos, or metadata uploaded to FT
              Tunes. Unauthorized use of copyrighted material is strictly
              prohibited.
            </p>
          </div>

          {/* Section 2 */}
          <div className="policy-section card-gradient-border">
            <h2 className="section-title">
              <span className="section-number red-gradient">2</span>
              <FaBan className="section-icon-inline mr-2 text-red" />{" "}
              Prohibited Content
            </h2>
            <p className="section-text mb-2">The following types of content are not allowed:</p>
            <ul className="custom-list red-bullets mb-3">
              <li>Copyrighted material without permission</li>
              <li>Hate speech or discriminatory content</li>
              <li>Violence promotion or harmful behavior</li>
              <li>Harassment, bullying, or abusive material</li>
              <li>Sexually explicit or pornographic material</li>
              <li>Fraudulent or misleading metadata</li>
              <li>Spam uploads or manipulated streaming activity</li>
            </ul>
          </div>

          {/* Section 3 */}
          <div className="policy-section card-gradient-border">
            <h2 className="section-title">
              <span className="section-number blue-gradient">3</span>
              <FaMusic className="section-icon-inline mr-2 text-blue" />{" "}
              Music Distribution Standards
            </h2>
            <p className="section-text">
              All uploads must meet professional industry standards. Audio
              quality, artwork resolution, and metadata accuracy must comply with
              digital store requirements such as Spotify, Apple Music, YouTube
              Music, and other platforms.
            </p>
          </div>

          {/* Section 4 */}
          <div className="policy-section card-gradient-border">
            <h2 className="section-title">
              <span className="section-number pink-gradient">4</span>
              <FaGavel className="section-icon-inline mr-2 text-pink" />{" "}
              Copyright Violations
            </h2>
            <p className="section-text">
              FT Tunes respects intellectual property rights. If a copyright owner
              reports unauthorized use, the content may be removed immediately
              while the matter is reviewed. Repeat violations may result in
              permanent account suspension.
            </p>
          </div>

          {/* Section 5 */}
          <div className="policy-section card-gradient-border">
            <h2 className="section-title">
              <span className="section-number orange-gradient">5</span>
              <FaExclamationTriangle className="section-icon-inline mr-2 text-orange" />{" "}
              Artificial Streaming & Fraud
            </h2>
            <p className="section-text">
              Users must not engage in artificial streaming practices, including
              bots, paid streams, fake listeners, or manipulation of charts and
              analytics. Any fraudulent activity may result in revenue withholding
              or account termination.
            </p>
          </div>

          {/* Cards grid for smaller sections */}
          <div className="cards-grid-2">
            {/* Section 6 */}
            <div className="policy-section card-gradient-border">
              <h2 className="section-title">
                <span className="section-number green-gradient">6</span>
                <FaUsersCog className="section-icon-inline mr-2 text-green" />{" "}
                Content Review & Moderation
              </h2>
              <p className="section-text">
                FT Tunes reserves the right to review, reject, edit, or remove any
                content that violates our policies or platform partner guidelines.
              </p>
            </div>

            {/* Section 7 */}
            <div className="policy-section card-gradient-border">
              <h2 className="section-title">
                <span className="section-number purple-gradient">7</span>
                <FaUserCheck className="section-icon-inline mr-2 text-purple" />{" "}
                User Responsibility
              </h2>
              <p className="section-text">
                Users are solely responsible for the content they upload. FT Tunes
                does not assume liability for user-generated material distributed
                through the platform.
              </p>
            </div>
          </div>

          {/* Section 8 */}
          <div className="policy-section card-gradient-border">
            <h2 className="section-title">
              <span className="section-number red-gradient">8</span>
              <FaBan className="section-icon-inline mr-2 text-red" />{" "}
              Policy Enforcement
            </h2>
            <p className="section-text mb-2">
              Violation of this Content Policy may result in:
            </p>
            <ul className="custom-list mb-3">
              <li>Content removal</li>
              <li>Distribution suspension</li>
              <li>Revenue hold or cancellation</li>
              <li>Permanent account termination</li>
            </ul>
          </div>

          {/* Section 9 */}
          <div className="policy-section card-gradient-border">
            <h2 className="section-title">
              <span className="section-number pink-gradient">9</span>
              <FaSyncAlt className="section-icon-inline mr-2 text-pink" />{" "}
              Updates to Policy
            </h2>
            <p className="section-text">
              FT Tunes may update this Content Policy periodically to comply with
              legal requirements and industry standards. Continued use of our
              services indicates acceptance of any updates.
            </p>
          </div>

        </div>
      </Container>
    </div>
  );
};

export default ContentPolicy;